import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BlogService {

  constructor(private http: HttpClient) { }

  baseUrl: string | undefined = 'https://zumera-backend.onrender.com';
 
  getBlogList(){

    return this.http.get(
      `${this.baseUrl}/blogs`,
    );
  }
  
  getSingleBlog(id:any){

    return this.http.get(
      `${this.baseUrl}/blogs/${id}`,
    );
  }
}
